//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { historyFlowList, leaveDetail } from "@/api/work/process";
export default {
  data: function data() {
    return {
      businessId: '',
      processInstanceId: '',
      src: '',
      flowList: [],
      form: {
        flow: {
          assigneeName: ''
        },
        startTime: '',
        endTime: '',
        reason: ''
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.processInstanceId = this.$route.params.processInstanceId;
      this.businessId = this.$route.params.businessId;
      this.src = "/api/blade-flow/process/diagram-view?processInstanceId=".concat(this.$route.params.processInstanceId);
      historyFlowList(this.processInstanceId).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this.flowList = data.data;
        }
      });
      leaveDetail(this.businessId).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this.form = data.data;
        }
      });
    },
    handleCancel: function handleCancel() {
      this.$router.$avueRouter.closeTag();
      this.$router.push({
        path: "/work/start"
      });
    }
  }
};